import {
	required,
	dateValidation,
	minYear,
	minLength2,
	maxLength100,
} from "validators";

export const validateOwner = [required, minLength2, maxLength100];

export const requiredIfNotCheckedProceedWithoutTIN = (value, allValues) => {
	return !value && !allValues.proceedWithoutTIN
		? "Field is required"
		: undefined;
};

export const minLengthSSN = value => {
	return value && value.length < 11 ? `Min length is 9 symbols` : undefined;
};

export const maxLengthSSN = value => {
	return value && value.length > 11 ? `Max length is 9 symbols` : undefined;
};

export const validateSSN = [
	requiredIfNotCheckedProceedWithoutTIN,
	minLengthSSN,
	maxLengthSSN,
];

export const validateDOB = [required, dateValidation, minYear(1900)];
